import { Alert, Autocomplete, Box, Button, Card, CardContent, CardHeader, Collapse, Grid, IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { NumberFormatMoney } from "../useForm";
import MontosListado from "./MontosListado";
import TipsAndUpdatesTwoToneIcon from '@mui/icons-material/TipsAndUpdatesTwoTone';

const anioActual = (new Date()).getFullYear()
//console.log(`anioActual ${anioActual}`)
const anioSiguiente = anioActual + 1

const options = [`${anioActual}`, `${anioSiguiente}`]

export default function Montos() {
    const params = useParams()
    const [configuracion, setConfiguracion] = useState({ "idEntidad": params.idEntidad });
    // const [isEditing, setIsEditing] = useState(false)
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [value, setValue] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [guardado, setGuardado] = useState(false);
    const [severity, setSeverity] = useState('error')

    const cargarConfiguracion = async (anio) => {
        if (anio) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionMontos/configuracion/${anio}/${params.idEntidad}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            }

            )
            if (res.status === 404) {
                setOpen(true)
                setSeverity('info')
                setMensaje(`Esa configuración de montos no existe${anio < anioActual ? '.' : ', puede registrarla'}`)
                setConfiguracion({ "anio": anio, "idEntidad": params.idEntidad, "montoMaximoNacionalDia": '', "montoMaximoInternacionalDia": '' })
            }
            else {
                setOpen(true)
                setSeverity('info')
                setMensaje(`Esa configuración de montos ya existe${anio < anioActual ? ', sólo puede consultarla.' : ', puede modificarla'}`)
                const data = await res.json()
                //console.log(data)

                setConfiguracion(data)
            }
        }
    }

    const handleChange = e => {
        setConfiguracion({ ...configuracion, [e.target.name]: e.target.value })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (configuracion.montoMaximoNacionalDia && isNaN(configuracion.montoMaximoNacionalDia))
            configuracion.montoMaximoNacionalDia = configuracion.montoMaximoNacionalDia.replace(/,/g, '')
        if (configuracion.montoMaximoInternacionalDia && isNaN(configuracion.montoMaximoInternacionalDia))
            configuracion.montoMaximoInternacionalDia = configuracion.montoMaximoInternacionalDia.replace(/,/g, '')
        setLoading(true)
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionMontos/guardar`, {
            method: "POST",
            body: JSON.stringify(configuracion),
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
        })
        const data = await res.json()
        setOpen(true)
        //console.log(JSON.stringify(data))
        if(res.status === 200)
            setSeverity('success')
        else
            setSeverity('error')
        if (data.message) {
            setMensaje(data.message)

        }
        else {
            setConfiguracion({ "anio": null, "idEntidad": params.idEntidad, "montoMaximoNacionalDia": '', "montoMaximoInternacionalDia": '' })
            setValue(null)
            setMensaje('La configuración se ha guardado')
            setGuardado(true)

        }
        setLoading(false)
    }
    return (
        <>
            <MontosListado idEntidad={params.idEntidad} guardado={guardado} setGuardado={setGuardado} />
            <Grid item xs={12} style={{ marginTop: 15 }}>
                <Card>
                    <CardHeader title='Configuración de Montos de la Gestión del Presupuesto' />
                    <CardContent>
                        <form id='guardarProyectoPlan' onSubmit={handleSubmit}>
                        <Grid container direction='row' justifyContent='center' spacing={2}>
                                <Grid item>
                                    <Autocomplete
                                        value={value}
                                        onKeyDown={async(event) => {
                                            if (event.key === 'Enter') {
                                                setValue(event.target.value)
                                                await cargarConfiguracion(event.target.value)
                                            }
                                        }
                                        }

                                        onChange={async(event, newValue) => {
                                            setValue(newValue);
                                            //console.log(newValue)
                                            setConfiguracion({ "anio": newValue, "idEntidad": params.idEntidad, "montoMaximoNacionalDia": '', "montoMaximoInternacionalDia": '' })

                                            setMensaje('')
                                            setOpen(false)
                                            if (newValue !== null) {
                                                await cargarConfiguracion(newValue)
                                                return
                                            }
                                        }}
                                        inputValue={inputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setInputValue(newInputValue);
                                        }}
                                        id="anio"
                                        name="anio"
                                        options={options}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => <TextField {...params} label="Año" focused />}
                                    />
                                    <Tooltip title="Para consultar se puede escribir el año y presionar la tecla enter" arrow>
                                        <TipsAndUpdatesTwoToneIcon sx={{ color: 'orange' }} />
                                    </Tooltip>
                                </Grid>

                                <Grid item>
                                    <TextField name='montoMaximoNacionalDia' label="Monto Máximo de Viáticos Nacionales por Día" sx={{ width: 300 }} InputProps={{
                                        inputComponent: NumberFormatMoney,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                $
                                            </InputAdornment>
                                        ),
                                    }} value={configuracion.montoMaximoNacionalDia} onChange={handleChange} />
                                </Grid>

                                <Grid item>
                                    <TextField name='montoMaximoInternacionalDia' label="Monto Máximo de Viáticos Internacionales por Día" sx={{ width: 300 }} InputProps={{
                                        inputComponent: NumberFormatMoney,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                $
                                            </InputAdornment>
                                        ),
                                    }} value={configuracion.montoMaximoInternacionalDia} onChange={handleChange} />
                                </Grid>



                                <Grid item paddingY={5}>
                                    <Button variant='contained' color='primary' type='submit' disabled={!configuracion.montoMaximoNacionalDia || !configuracion.montoMaximoInternacionalDia || configuracion.anio < anioActual || loading}>
                                        Guardar
                                    </Button>

                                </Grid>
                            </Grid>

                        </form>
                        <Box sx={{ width: '100%' }}>
                            <Collapse in={open}>
                                <Alert severity={severity}
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setOpen(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                    style={{ marginTop: 30 }}
                                >
                                    {mensaje}

                                </Alert>
                            </Collapse>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </>
    )

}